module.exports = __webpack_public_path__ + "img/Team_MV.bc80dbe1.png";